import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    userInfo:null
}

export default new Vuex.Store({
    state,
    mutations:{
        SET_USERINFO: (state, userInfo) => {
            state.userInfo = userInfo;
        },
    },
    getters:{
        userInfo: state => state.userInfo
    }
})